import { makeStyles } from '@material-ui/core';

export default makeStyles({
  toppingList: {
    margin: '0 0 0.125rem 0.5rem',
    listStyleType: 'none',
    listStylePosition: 'inside',
  },
});
